module.exports = __webpack_public_path__ + "static/media/icCampaign.04a725e5.svg";